import { useEffect, useState } from "react";
import ButtonComponent from "../elements/ButtonComponent";
import { axiosPrivate } from "../../api/axios";
import { POLICY_URL, USER_USER_GET_POLICY } from "../../api/apiClient";
import animationData from "../../jsons/Loading333.json";
import Lottie from "react-lottie";

const AcceptRules = ({
  modalContentRef,
  onRulesAccepted,
  closeModalNotSetPassword,
}: any) => {
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingRules, setLoadingRules] = useState(false);
  const [policy, set_Policy] = useState("");

  const access_token = localStorage.getItem("access_token");

  useEffect(() => {
    const checkScroll = () => {};

    const currentRef = modalContentRef.current;
    if (currentRef) {
      currentRef.addEventListener("scroll", checkScroll);
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener("scroll", checkScroll);
      }
    };
  }, [modalContentRef]);

  const acceptRules = async () => {
    try {
      setIsLoading(true);
      const response = await axiosPrivate.post(
        POLICY_URL,
        {},
        {
          headers: {
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            // prettier-ignore
            "accept": "application/json",
          },
        }
      );
      if (response?.status >= 200) {
        onRulesAccepted();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleScroll = () => {
    if (
      modalContentRef.current &&
      modalContentRef.current.scrollTop +
        modalContentRef.current.clientHeight +
        50 >=
        modalContentRef.current.scrollHeight - 1
    ) {
      setIsScrolledToBottom(true);
    } else {
    }
  };

  const getPolicy = async () => {
    setLoadingRules(true);
    try {
      await axiosPrivate
        .get(USER_USER_GET_POLICY, {
          headers: {
            Authorization:
              "Bearer " + window.localStorage.getItem("access_token"),
          },

          withCredentials: true,
        })
        .then((res: any) => {
          set_Policy(res.data.data.user_policy);
          setLoadingRules(false);
        });
    } catch (e) {
      setLoadingRules(false);
    }
  };
  useEffect(() => {
    getPolicy();
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  return (
    <>
      {loadingRules ? (
        <>
          <div className=" h-[500px] flex items-center justify-center mx-auto z-10 ">
            <Lottie options={defaultOptions} height={100} width={100} />
          </div>
        </>
      ) : (
        <>
          <div className=" flex items-end justify-between rounded-t p-6 border-b-2">
            <p className="text-Title/20/Bold">
              وام گرفتن در
              <span className="text-primary-600"> وامسی </span>
            </p>
            <button
              type="button"
              onClick={() => {
                closeModalNotSetPassword();
              }}
              className="text-gray-700 bg-transparent rounded-lg w-8 h-8 inline-flex justify-end items-center  "
            >
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div
            ref={modalContentRef}
            onScroll={handleScroll}
            className="p-4 md:p-6 space-y-4 overflow-y-auto max-h-[356px]"
          >
            {policy.split("\r\n").map((item, index) => (
              <p key={index} className="text-Title/16/Bold">
                {item}
              </p>
            ))}
          </div>
          <div className="flex items-center p-4 md:p-5  border-t border-gray-200 rounded-b d">
            <ButtonComponent
              onClick={acceptRules}
              disabled={!isScrolledToBottom}
              isClicked={isLoading}
            >
              شرایط را می پذیرم
            </ButtonComponent>
          </div>{" "}
        </>
      )}
    </>
  );
};

export default AcceptRules;
